import { Tabs } from "antd";

import SentenceEng from "./SentenceManage/SentenceEng";
import SentenceInterpretation from "./SentenceManage/SentenceInterpretation";
import SentenceAI from "./SentenceManage/SentenceAI";
import SentencePrompt from "./SentenceManage/SentencePrompt";
import SentenceImage from "./SentenceManage/SentenceImage";
import { useState } from "react";
import SentenceImagePrompt from "./SentenceManage/SentenceImagePrompt";

const backend = process.env.REACT_APP_BACKEND

function SentenceManage () {
  const [filter, setFilter] = useState({
    group: "all",
    course: "all",
    stage: "all",
    chapter: "all",
    unit: "all",
    subUnit: "all",
    sentenceStatus: "all",
  })

  const filterHandler = (filters) => {
    setFilter(filters)
  }
    // useEffect(()=>{
    //     axios.get(`${backend}/contents/code`)
    //     .then(data=>{
    //         console.log(data)
    //     })
    //     .catch(err=>{
    //         console.log(err)
    //     })
    // })

    const items = [
        { label: "영어", key: "item-1", style:{height:"100%"}, children: <SentenceEng filter={filter} filterHandler={filterHandler}/> }, // remember to pass the key prop
        { label: "해석", key: "item-2", style:{height:"100%"}, children: <SentenceInterpretation filter={filter} filterHandler={filterHandler}/> },
        { label: "AI", key: "item-3", style:{height:"100%"}, children: <SentenceAI filter={filter} filterHandler={filterHandler}/> },
        { label: "프롬프트", key: "item-4", style:{height:"100%"}, children: <SentencePrompt /> },
        { label: "이미지", key: "item-5", style:{height:"100%"}, children: <SentenceImage filter={filter} filterHandler={filterHandler}/> },
        { label: "프롬프트", key: "item-6", style:{height:"100%"}, children: <SentenceImagePrompt filter={filter} filterHandler={filterHandler}/> },

      ];
    
      return (
        <div style={{width:"100%", height:"100%"}}>
          <Tabs defaultActiveKey="item-1" destroyInactiveTabPane={true} type="card" size="middle" items={items} style={{height:"100%", width:"100%"}}/>
        </div>
      );
}

export default SentenceManage